import React, { useState } from 'react'
import { Grid, Icon, Loader } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector, useDispatch } from 'react-redux'
import { formatDate } from '../../util'
import {
  addItemsTabWarnings,
  deleteItemsTabWarnings,
} from '../../../commonActions/serverErrorAction'
import { getValidationError as ValidationError } from '../../Helper'
import DeleteIcon from '../../../commonComponents/deleteIcon'
import CopyRepElement from '../../../GB_App/formSections/itemsTab/copyRepElement'

const SupportingDocumentDetails = ({
  item: { code, documentDate, infoId, ref, merchandiseId },
  infoIndex,
  translate,
  updateItem,
  saveItem,
  copyData,
  deleteItem,
  isFormDisabled,
  lineItemIndex,
  invoiceIndex,
}) => {
  const dispatch = useDispatch()
  const docCodesList = useSelector((state) => state.DropDownValues.additionalInfoCodes)

  const getValidationError = (field, value, Level, onlyMandatoryCheck) =>
    ValidationError(field, value, Level, onlyMandatoryCheck, '', translate)

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }

  return (
    <Grid.Row>
      <Grid.Column width={1} style={{ textAlign: 'center' }}>
        <CopyRepElement
          title={`SUP_DOCS`}
          request={{ infoId: '', code, documentDate, ref }}
          callback={copyData}
          isFormDisabled={isFormDisabled}
        />
      </Grid.Column>
      <Grid.Column width='4' className='divFormFeild border-bottom b-rw-0'>
        <DropDown
          idText={`DocCode-${infoId}-${merchandiseId}`}
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          label={translate('DOC_CODE', { ns: ['default', 'lineItem'] })}
          labelClass='text-none'
          isLabel={true}
          mandatory={false}
          direction={'right'}
          data={docCodesList}
          errors={getValidationError('addinfocode', code, 'itemsTab', true)}
          value={code}
          clearable
          onChange={(value) => {
            updateItem(infoId, {
              code: value?.trim(),
            })
            saveItem({ infoId, code: value })
            let err = getValidationError('addinfocode', value, 'itemsTab', true)
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                    ' :: ' +
                    err[0],
                  `addinfocode-${merchandiseId}-${infoIndex}`
                )
              : deleteErrors('itemsTab', '', `addinfocode-${merchandiseId}-${infoIndex}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='4' className='divFormFeild  border-bottom datepicker1'>
        <InputField
          isLabel={false}
          id={`DOC_DATE-${infoId}-${merchandiseId}`}
          type='date'
          disabled={isFormDisabled}
          label={translate('DOC_DATE', { ns: ['default', 'lineItem'] })}
          className='field-bg'
          errors={getValidationError('addinfodocumentDate', documentDate, 'itemsTab', true)}
          value={documentDate ? new Date(documentDate).getTime() : '-999'}
          onChange={(value) => {
            if (value) {
              value = formatDate(value)
            } else {
              value = -999
            }
            updateItem(infoId, { documentDate: value })
            saveItem({ infoId, documentDate: documentDate })
            let err = getValidationError('addinfocode', value, 'itemsTab', true)
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                    ' :: ' +
                    err[0],
                  `addinfodocumentDate-${merchandiseId}-${infoIndex}`
                )
              : deleteErrors('itemsTab', '', `addinfodocumentDate-${merchandiseId}-${infoIndex}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='6' className='divFormFeild border-bottom'>
        <InputField
          isLabel={false}
          id={`reference-${infoId}-${merchandiseId}`}
          type='text'
          label={translate('REF', { ns: ['default', 'lineItem'] })}
          value={ref || ''}
          className={'field-bg'}
          errors={getValidationError('addinforef', ref || '', 'itemsTab')}
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) => {
            updateItem(infoId, { ref: value })
          }}
          onBlur={(value) => {
            saveItem({ infoId, ref: value })
            let err = getValidationError('addinforef', ref || '', 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line 00${lineItemIndex + 1}.` +
                    ' :: ' +
                    err[0],
                  `addinforef-${merchandiseId}-${infoIndex}`
                )
              : deleteErrors('itemsTab', '', `addinforef-${merchandiseId}-${infoIndex}`)
          }}
        />
      </Grid.Column>

      <Grid.Column width={1} className='icon-delete-add-info'>
        <DeleteIcon onClick={() => deleteItem(infoId)} disabled={isFormDisabled} />
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(SupportingDocumentDetails)
